export default __webpack_public_path__ + "static/media/banner_principal2.2691a442.jpg";